"use client";

import { Badge } from "flowbite-react";
import { motion, AnimatePresence } from "framer-motion";
import projectImage from "../profile/dabs.png";
import projectImage3 from "../profile/dashboard.png";
import projectImage4 from "../profile/OJTtimecalculator.png";
import proj2 from "../profile/proj2.png";
import projectImage2 from "../profile/Random-Fact-generator.png";
import { useState } from "react";

function Projects() {
  const [activeProject, setActiveProject] = useState("web");

  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const projectVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  const projects = {
    web: [
      {
        title: "OJT Time Calculator",
        description: "A web application built with TypeScript that helps calculate required OJT hours, working days, and completion dates. Features include holiday/absence tracking, working hours customization, and progress visualization.",
        image: projectImage4,
        tags: ["TypeScript", "React", "Tailwind CSS", "Time Management"],
        tagColors: ["blue", "yellow", "cyan", "purple"],
        link: "https://github.com/joshuadeguino/ojtcalculator",
        demoLink: "https://timecalculator-opal.vercel.app/"
      },
      {
        title: "Web-based system for computer reservation in a University Library",
        description: "A Full stack web-based system for computer reservation in a University Library built with Next.js and Supabase. Features user management, session logs, queuing systems, and computer availability tracking.",
        image: projectImage3,
        tags: ["Next.js", "React", "Supabase", "University System", "API"],
        tagColors: ["blue", "yellow", "green", "purple", "red"],
        link: "https://github.com/username/campus-reserve-nexus",
        demoLink: "https://computer-tracking-system.vercel.app/"
      },
      {
        title: "DABS E-COMMERCE PROJECT",
        description: "A full stack web-based system. DABS is a E-COMMERCE web-based system focused on computer peripherals.",
        image: projectImage,
        tags: ["PHP", "JavaScript", "MySql"],
        tagColors: ["blue", "yellow", "red"],
        link: "https://github.com/joshuadeguino/dabslatest",
        demoLink: null
      },
      {
        title: "E-COMMERCE WITH MAGNIFYING",
        description: "A JavaScript-focused e-commerce project featuring advanced functionality like sorting, image magnification, and search capabilities.",
        image: proj2,
        tags: ["JavaScript", "HTML", "CSS"],
        tagColors: ["yellow", "orange", "blue"],
        link: "https://github.com/joshuadeguino/e-commerce-with-magnifying",
        demoLink: "https://joshuadeguino.github.io/e-commerce-with-magnifying/"
      }
    ],
    mobile: [
      {
        title: "RANDOM FACT GENERATOR",
        description: "A React Native app fetching random facts, providing users with interesting and engaging content on-the-go.",
        image: projectImage2,
        tags: ["React Native", "JavaScript", "REST API"],
        tagColors: ["blue", "yellow", "red"],
        link: null
      }
    ]
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1A1F2C] via-[#222222] to-[#1A1F2C] py-20 px-6 md:px-8 animated-bg relative overflow-hidden">
      {/* Vital Signs Wave with Traveling Light */}
      <svg
        className="absolute left-0 bottom-0 w-full h-64 z-0 pointer-events-none"
        viewBox="0 0 1440 320"
        style={{ opacity: 0.28 }}
      >
        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="8" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
          <linearGradient id="vitalGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#9b87f5" />
            <stop offset="100%" stopColor="#7ee8fa" />
          </linearGradient>
          <radialGradient id="glowGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#7ee8fa" stopOpacity="1" />
            <stop offset="60%" stopColor="#9b87f5" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#9b87f5" stopOpacity="0" />
          </radialGradient>
          <filter id="glowBlur" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="12" />
          </filter>
          <path
            id="vitalPath"
            d="M0,200 L200,200 L260,120 L320,280 L400,80 L480,240 L560,200 L1440,200"
          />
        </defs>
        {/* Vital signs wave line */}
        <use
          href="#vitalPath"
          stroke="url(#vitalGradient)"
          strokeWidth="6"
          fill="none"
        >
          <animate
            attributeName="stroke"
            values="url(#vitalGradient);#9b87f5;url(#vitalGradient)"
            dur="8s"
            repeatCount="indefinite"
          />
        </use>
        {/* Traveling glowing color */}
        <ellipse
          rx="28"
          ry="16"
          fill="url(#glowGradient)"
          filter="url(#glowBlur)"
        >
          <animateMotion
            dur="4s"
            repeatCount="indefinite"
            keyPoints="0;1"
            keyTimes="0;1"
            calcMode="linear"
          >
            <mpath href="#vitalPath" />
          </animateMotion>
          <animate
            attributeName="opacity"
            values="1;0.7;1"
            dur="1.2s"
            repeatCount="indefinite"
          />
        </ellipse>
      </svg>
      {/* Floating Particles */}
      <div className="floating-particles">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 15}s`,
              animationDuration: `${15 + Math.random() * 10}s`
            }}
          />
        ))}
      </div>
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-16">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center gap-3 mb-6 md:mb-0"
          >
            <Badge 
              className="px-4 py-2 text-lg font-mono bg-[#9b87f5]/10 text-[#9b87f5] border-none tracking-wider"
              icon={() => <i className="fas fa-code mr-2"></i>}
            >
              PROJECTS
            </Badge>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center gap-4"
          >
            <button
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-300 ${
                activeProject === "web" 
                  ? "bg-[#9b87f5] text-white shadow-lg shadow-[#9b87f5]/30" 
                  : "bg-[#403E43] text-white/70 hover:bg-[#7E69AB]"
              }`}
              onClick={() => setActiveProject("web")}
            >
              <i className="fas fa-globe mr-2"></i> Web Projects
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-300 ${
                activeProject === "mobile" 
                  ? "bg-[#9b87f5] text-white shadow-lg shadow-[#9b87f5]/30" 
                  : "bg-[#403E43] text-white/70 hover:bg-[#7E69AB]"
              }`}
              onClick={() => setActiveProject("mobile")}
            >
              <i className="fas fa-mobile-alt mr-2"></i> Mobile Apps
            </button>
          </motion.div>
        </div>

        {/* Projects Grid */}
        <AnimatePresence mode="wait">
        <motion.div
          key={activeProject}
          variants={containerVariants}
          initial="hidden"
          animate="show"
          exit="hidden"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {projects[activeProject].map((project, index) => (
            <motion.div
              key={index}
              variants={projectVariants}
              className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm 
                       hover:from-white/15 hover:to-white/10 transition-all duration-500 p-6"
            >
              {/* Project Image */}
              <div className="aspect-video overflow-hidden rounded-xl mb-6">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 
                             group-hover:from-black/70 transition-all duration-500" />
              </div>

              {/* Project Info */}
              <div className="space-y-4">
                <h3 className="tech-heading text-white group-hover:text-[#9b87f5] transition-colors duration-300">
                  {project.title}
                </h3>
                <p className="tech-text text-white/70 text-sm leading-relaxed">
                  {project.description}
                </p>
                
                {/* Tags */}
                <div className="flex flex-wrap gap-2 pt-2">
                  {project.tags.map((tag, idx) => (
                    <span 
                      key={idx}
                      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-sf-mono
                              bg-${project.tagColors[idx]}-500/20 text-${project.tagColors[idx]}-400
                              border border-${project.tagColors[idx]}-500/30`}
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Links */}
                <div className="flex gap-4">
                  {project.link && (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-[#9b87f5] hover:text-[#8b77e5] transition-colors pointer-events-auto z-10 font-sf-mono text-sm"
                    >
                      <i className="fab fa-github mr-2"></i>
                      View on GitHub
                    </a>
                  )}
                  {project.demoLink && (
                    <a
                      href={project.demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-[#9b87f5] hover:text-[#8b77e5] transition-colors pointer-events-auto z-10 font-sf-mono text-sm"
                    >
                      <i className="fas fa-external-link-alt mr-2"></i>
                      Live Demo
                    </a>
                  )}
                </div>
              </div>

              {/* Hover Overlay */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#9b87f5]/50 
                           rounded-2xl transition-all duration-500 pointer-events-none" />
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
    </div>
  );
}

export default Projects;